import { i18nLanguage } from './i18nLanguage.type';

import { de, enUS, nb } from '../utils';

export const availableLanguages: i18nLanguage[] = [
  { code: 'no', dateLocale: nb, numberLocale: 'nb', inputLang: 'nb', datepickerLocale: nb, datepickerFormat: 'P' },
  { code: 'en', dateLocale: nb, numberLocale: 'en-US', inputLang: 'nb', datepickerLocale: enUS, datepickerFormat: 'dd.MM.yyyy' },
];

export const defaultLanguage = availableLanguages[0];
